import React, {useEffect} from "react";
import {ShoppingFunnelIO} from "../../../io/content/ShoppingFunnelIO";
import {ShoppingTotalMetricsValueObject} from "../../../model/vo/content/ShoppingTotalMetricsValueObject";
import {useError, useStatePair} from "../../../type/States";
import {Button, Input} from "@fluentui/react-components";
import CommonDialog from "./Dialog";

const onFormatDate = (date?: Date): string => {

    if(date == undefined) return ''

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
};

const isValidDateFormat = (dateStr: string): boolean => {
    const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    return regex.test(dateStr);
}

export default function TotalMetricDialog () {

    const [value, setValue] = React.useState<string>(onFormatDate(new Date()));
    const datePickerRef = React.useRef<HTMLInputElement>(null);

    const totalMetricErrorState = useError()
    const totalMetricData = useStatePair<ShoppingTotalMetricsValueObject | null>(null)

    const getTotalmetric = () => {

        if(!isValidDateFormat(value)){
            alert(value+"년-월-일 형식으로 작성해주세요.")
            return
        }

        if(value) {
            ShoppingFunnelIO.getShoppingTotalMetrics(value)
                .then(value => {
                    console.log(value);
                    totalMetricData.setValue(value);
                })
                .catch(totalMetricErrorState.setDefinedValue);
        }
    }

    useEffect(() => {
        getTotalmetric();
    }, []);

    return <>
        {
            totalMetricData.value != null && (
                <CommonDialog
                    dialogContent={totalMetricData.value}
                    description={ShoppingTotalMetricsValueObject.description}
                    dialogTitle="통계데이터 확인"
                >
                    <form style={{display: 'flex', gap:'8px'}}
                          onSubmit={(e) => {
                              e.preventDefault();
                              getTotalmetric();
                          }}>
                        <Input
                            value={value}
                            onChange={
                                (_, data) => setValue(data.value)}/>
                        <Button type="submit" appearance={'primary'}>
                            확인
                        </Button>
                    </form>
                </CommonDialog>
            )
        }
    </>
}